import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '..';
@Injectable()
export class TimKiemService {

  APIURL = "api/ExcuteOracle";
  constructor(private api: ApiService) { }
  private _listners = new Subject<any>();

  listen(): Observable<any> {
    return this._listners.asObservable();
  }

  timKiem(keyword: string) {
    this._listners.next(keyword);
  }
  timKiemDiemDo(keyword, mataikhoan, sotrang, sodong) {

    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_TIMKIEM_DIEMDO"}',
      "para": '{"v_keyword":"' + keyword + '","v_danhmucid":"0","v_mataikhoan":"' + mataikhoan + '","v_sotrang":"' + sotrang + '","v_sodong":"' + sodong + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  timKiemAutoComplete(keyword) {

    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_TIMKIEM_KEYWORD"}',
      "para": '{"v_keyword":"' + keyword + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/timkiem.service.ts